import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getEvent, updateEvent } from '../api/events';
import EventForm from '../components/EventForm';
import { useAuth } from '../contexts/AuthContext';

function EditEvent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin } = useAuth();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/signin');
    } else if (!isAdmin) {
      navigate('/events');
    }
  }, [isAuthenticated, isAdmin, navigate]);

  useEffect(() => {
    if (isAuthenticated && id) {
      fetchEvent();
    }
  }, [id, isAuthenticated]);

  const fetchEvent = async () => {
    try {
      setLoading(true);
      const data = await getEvent(id);
      setEvent(data.event);
    } catch (err) {
      setError('Failed to load event');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      await updateEvent(id, formData);
      navigate(`/events/${id}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isAuthenticated || !isAdmin) return null;
  if (loading) return <div className="loading">Loading event...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="edit-event">
      <Link to={`/events/${id}`} className="back-link">← Back to Event</Link>
      <h1>Edit Event</h1>
      <EventForm event={event} onSubmit={handleSubmit} isLoading={isSubmitting} />
    </div>
  );
}

export default EditEvent;
